/**
 * 用 App 顶部那条全局提示（App.tsx 的 setToast）。
 *
 * 播放弹窗挂在很多页面的深处（面包屑、字段标签、版本条），一路传 onToast 太散；
 * 这里发一个窗口事件，App 收到后照常 setToast。没有 App 监听时（单独渲染组件）只是没有提示。
 */
export const TOAST_EVENT = "piggo-toast";
export interface ToastDetail { msg: string; bad?: boolean }

export function showToast(msg: string, bad?: boolean) {
  window.dispatchEvent(new CustomEvent<ToastDetail>(TOAST_EVENT, { detail: { msg, bad } }));
}
